import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Combines multiple class names using clsx and tailwind-merge
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Checks if a font is loaded
 */
export function isFontLoaded(fontFamily: string): Promise<boolean> {
  return document.fonts.ready.then(() => {
    return document.fonts.check(`1em "${fontFamily}"`);
  });
} 